import type { ParticipantWithDetails } from '@/Services/eventParticipants.service';

/** Best phone we have for a participant: the form, else the minister record, else the guest */
export function participantPhone(p: ParticipantWithDetails): string | null {
  const fromForm = (p.registration_data as { cell_phone?: string } | null)?.cell_phone;
  return fromForm || p.minister?.cell_phone || p.guest?.phone || null;
}
